import { Grid, GridSize } from "@mui/material";
import React from "react";
import { Breakpoint } from "@mui/material/styles";

type Props = Omit<React.ComponentProps<typeof Grid>, "size"> & {
  size?: {
    [key in Breakpoint]?: GridSize | null;
  };
};

const GridItem = ({ size, ...props }: Props): React.JSX.Element => {
  return (
    <Grid {...props} size={{ xs: 12, ...size }}>
      {props.children}
    </Grid>
  );
};

export default GridItem;
